import React, {useEffect, useState} from 'react';
import {PageHeader} from "../../../components/PageHeader";
import {isMobile, toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import RentalRequestUserListType from "./rentalRequestUserListType";
import RentalRequestUserThumbType from "./RentalRequestUserThumbType";
import useRequestData from "../../../hooks/useRequestData";
import {getRequestRentalUserList} from "../../../api/lifecycle/rental/rentalRequestService";

const RentalRequestUser = () => {
    const [listType, setListType] = useState(true);

    const initDate = {
        startDate: toKSTISOString(addYears(new Date(), -1)),
        endDate: toKSTISOStringEnd(addYears(new Date(), 0)),
    }

    useEffect(() => {
        if (isMobile) {
            // mobile
            setListType(false);
        }
    }, []);

    const {newData, pageInfo, dataHook} = useRequestData(getRequestRentalUserList, initDate, "rental_user");

    return (
        <div className={"common-container"}>
            <PageHeader header={"대여신청"}/>
            {listType ?
                <RentalRequestUserListType data={newData} date={initDate} pageInfo={pageInfo} dataHook={dataHook} />
                :
                <RentalRequestUserThumbType />
            }

        </div>
    );
};

export default RentalRequestUser;